/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Icon } from 'semantic-ui-react'
import { CardContent } from '../../../Shared/Card'
import { useTranslation } from 'react-i18next'
import { CardTitle } from '../../../Shared/CardTitle'
import React from 'react'

const NoTodayPositiveActivityCardContent = () => {
    const [t] = useTranslation()

    return (
      <CardContent
        css={css`
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            padding: .5rem 1rem 1rem 1rem;
        `}
      >
          <CardTitle
            title={t('dashboard.today_positive_activity.today')}
          />


          <div
            css={css`
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                gap: 1rem;
                text-align: center;
                color: #999;
                font-style: italic;
                flex-grow: 1;
            `}
          >
              <Icon name="hourglass start" size="huge"/>
              De nouvelles commandes arriverons bientôt.
          </div>
      </CardContent>
    )
}

export { NoTodayPositiveActivityCardContent }
